import React, {useRef, useState, useMemo} from 'react'
import JoditEditor from "jodit-react";
import { FormCustom } from '../../Components/Form/Form'
import { useEffect } from 'react';
import Controllers from '../../Api/Controllers';
import { useCallback } from 'react';
import Helpers from '../../Components/Helpers/Helpers';
import { SurfaceCard, PageHeader } from '../../Components/Ui'
import {toast} from 'react-toastify'
import ReactPlaceholder from 'react-placeholder/lib';
import { useHistory } from 'react-router-dom';

const btnPrimary = {
    borderRadius: 12,
    fontWeight: 700,
    minHeight: 42,
    width: '100%',
    padding: '0 18px',
    background: '#201030',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8
}

const Mision = ({ readonly }) => {
    const [ mision, setMision ] = useState({})
    const [ vision, setVision ] = useState({})
    const [ valoresOne, setValoresOne ] = useState({})
    const [ valoresTwo, setValoresTwo ] = useState({})
    const [ lealtad, setLealtad ] = useState({})
    const [ready, setReady] = useState(false)

    const history = useHistory()

    const config = useMemo(() => {
        if (readonly) {
            return {
                minHeight: 450,
                preset: 'inline',
                readonly
            }
        } else {
            return {
                minHeight: 450,
                language: 'es',
                askBeforePasteHTML: false,
                askBeforePasteFromWord: false,
            }
        }
    }, [readonly])

    useEffect(() => {
        Controllers.text.get_mision_vision().then(res => {
            setMision(res.data.mision)
            setVision(res.data.vision)
            setValoresOne(res.data.valores_one)
            setValoresTwo(res.data.valores_two)
            setLealtad(res.data.lealtad)
            setReady(true)
        })
    }, [])

    const editorMision = useRef(null)

    const contentHTMLMision = useMemo(() => {
        return <>
        <JoditEditor
            ref={editorMision}
            value={mision?.content_text ? mision.content_text : ''}
            config={config}
            tabIndex={1}
            onBlur={_ => {
                setMision({ ...mision, content_text: editorMision.current.value })
            }}
        /></>
    }, [editorMision, mision, config])

    const editorVision = useRef(null)

    const contentHTMLVision = useMemo(() => {
        return <>
        <JoditEditor
            ref={editorVision}
            value={vision?.content_text ? vision.content_text : ''}
            config={config}
            tabIndex={1}
            onBlur={_ => {
                setVision({ ...vision, content_text: editorVision.current.value })
            }}
        /></>
    }, [editorVision, vision, config])

    const editorValoresOne = useRef(null)

    const contentHTMLValoresOne = useMemo(() => {
        return <>
        <JoditEditor
            ref={editorValoresOne}
            value={valoresOne?.content_text ? valoresOne.content_text : ''}
            config={config}
            tabIndex={1}
            onBlur={_ => {
                setValoresOne({ ...valoresOne, content_text: editorValoresOne.current.value })
            }}
        /></>
    }, [editorValoresOne, valoresOne, config])

    const editorValoresTwo = useRef(null)

    const contentHTMLValoresTwo = useMemo(() => {
        return <>
        <JoditEditor
            ref={editorValoresTwo}
            value={valoresTwo?.content_text ? valoresTwo.content_text : ''}
            config={config}
            tabIndex={1}
            onBlur={_ => {
                setValoresTwo({ ...valoresTwo, content_text: editorValoresTwo.current.value })
            }}
        /></>
    }, [editorValoresTwo, valoresTwo, config])

    const editorLealtad = useRef(null)

    const contentHTMLLealtad = useMemo(() => {
        return <>
        <JoditEditor
            ref={editorLealtad}
            value={lealtad?.content_text ? lealtad.content_text : ''}
            config={config}
            tabIndex={1}
            onBlur={_ => {
                setLealtad({ ...lealtad, content_text: editorLealtad.current.value })
            }}
        /></>
    }, [editorLealtad, lealtad, config])

    const dataSubmit = useCallback(() => {
        return {
            p_mision: mision,
            p_vision: vision,
            p_valores_one: valoresOne,
            p_valores_two: valoresTwo,
            p_lealtad: lealtad
        }
    }, [mision, vision, valoresTwo, valoresOne, lealtad])

    const [loadSubmit, setLoadSubmit] = useState(false)

    const handleSubmit = ({ data }) => {
        setLoadSubmit(true)
        Controllers.text.mision_vision_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast, message: 'Cambios guardados correctamente.' })
            history.push(Helpers.config.convertUrl({ url: '/mision-vision' }))
        }).catch(req => Helpers.promise.catch({ req, toast }))
        .finally(() => {
            setLoadSubmit(false)
        })
    }

    return <>
        <PageHeader
            eyebrow="Super Papelera — Espacio de trabajo"
            title="Misión y Visión"
            subtitle="Edita los textos institucionales de misión, visión y valores."
        />
        <ReactPlaceholder ready={ready} showLoadingAnimation rows={15}>
            <FormCustom dataSubmit={dataSubmit()} onSubmit={handleSubmit} loadSubmit={loadSubmit} viewSubmit={false}>
                <div className={'mb-2 col-12 col-md-' + (readonly ? '12' : '9')}>
                    <SurfaceCard>
                        <div className="form-row">
                            <div className="col-12 col-md-6 mb-5">
                                <h3 className="text-center" style={{ color: '#201030', fontWeight: 700 }}>Misión</h3>
                                {contentHTMLMision}
                            </div>
                            <div className="col-12 col-md-6 mb-5">
                                <h3 className="text-center" style={{ color: '#201030', fontWeight: 700 }}>Visión</h3>
                                {contentHTMLVision}
                            </div>
                            <div className="col-12 mb-4">
                                <h3 className="text-center" style={{ color: '#201030', fontWeight: 700 }}>Valores</h3>
                            </div>
                            <div className="col-12 col-md-6 mb-5">
                                {contentHTMLValoresOne}
                            </div>
                            <div className="col-12 col-md-6 mb-5">
                                {contentHTMLValoresTwo}
                            </div>
                        </div>
                    </SurfaceCard>
                </div>
                {readonly ? '' : <div className="col-12 col-md-3">
                    <SurfaceCard title="Actualizar">
                        <p style={{ color: '#6B7280', fontSize: '0.9rem' }}>
                            Da click en el botón para guardar los cambios realizados.
                        </p>
                        <button type="submit" style={btnPrimary}>
                            {loadSubmit
                                ? <i className="fa fa-circle-notch fa-spin" />
                                : <><i className="fa fa-plus" />Guardar Cambios</>}
                        </button>
                    </SurfaceCard>
                </div>}
            </FormCustom>
        </ReactPlaceholder>
    </>
}

Mision.defaultProps = {
    readonly: false
}

export default Mision
